import React from 'react'
import {
  documentToReactComponents,
  Options,
} from '@contentful/rich-text-react-renderer'
import { Document } from '@contentful/rich-text-types'

export interface IRichTextFields {
  /** Content */
  content?: Document | undefined
  makeH2?: boolean | undefined
}

const RichText = ({ content, makeH2 }: IRichTextFields): JSX.Element => {
  if (content) {
    const options: Options = {
      renderText: (text) => {
        return <span dangerouslySetInnerHTML={{ __html: text }} />
      },
      renderMark: {
        sub: (text) => {
          return <sub>{text}</sub>
        },
      },
    }
    if (makeH2) {
      options.renderNode = {
        paragraph: (node, children) => {
          return <h2>{children}</h2>
        },
      }
    }
    const data = documentToReactComponents(content, options) as Array<any>

    return <div>{data}</div>
  }

  return <div></div>
}

export default RichText
